export default __webpack_public_path__ + "static/media/key.54452f4e.svg";